import React from 'react'
import {
  BooleanField,
  Datagrid,
  TextField,
  SelectInput,
  useTranslate,
  TextInput
} from 'react-admin'

import { ListBase } from '../../components/base'
import { DateField } from '../../components/fields'
import { COMMON_FIELDS, JOB_OPPORTUNITIES_FIELDS } from '../../providers/localization/constant'

const JobOpportunityList = (): JSX.Element => {
  const translate = useTranslate()
  const JobOpportunityListFilters = [
    <TextInput
      key={0}
      source='title'
      // InputLabelProps={{ shrink: true }}
      // InputProps={{ notched: false }}
      // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
      label={translate(`${JOB_OPPORTUNITIES_FIELDS}.title`)}
    />,
    <TextInput
      key={0}
      source='branch'
      // InputLabelProps={{ shrink: true }}
      // InputProps={{ notched: false }}
      // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
      label={translate(`${JOB_OPPORTUNITIES_FIELDS}.branch`)}
    />,
    <SelectInput
      key={1}
      label={`${COMMON_FIELDS}.published.label`}
      source='is_published'
      choices={[
        { id: 'true', name: `${COMMON_FIELDS}.published.choices.true` },
        { id: 'false', name: `${COMMON_FIELDS}.published.choices.false` },
      ]}
    />,
  ]
  return (
    <ListBase
      listAction={{
        hasExport: false,
      }}
      filters={JobOpportunityListFilters}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick='edit'>
        <TextField source='title_th' label={`${JOB_OPPORTUNITIES_FIELDS}.title_th`} sortable={false}></TextField>
        <TextField source='title_en' label={`${JOB_OPPORTUNITIES_FIELDS}.title_en`} sortable={false}></TextField>
        {/* <TextField source='description_th' label={`${JOB_OPPORTUNITIES_FIELDS}.description_th`}></TextField>
        <TextField source='description_en' label={`${JOB_OPPORTUNITIES_FIELDS}.description_en`}></TextField> */}
        <TextField source='branch_th' label={`${JOB_OPPORTUNITIES_FIELDS}.branch_th`} sortable={false}></TextField>
        <TextField source='branch_en' label={`${JOB_OPPORTUNITIES_FIELDS}.branch_en`} sortable={false}></TextField>
        <TextField source='experience_th' label={`${JOB_OPPORTUNITIES_FIELDS}.experience_th`} sortable={false}></TextField>
        <TextField source='experience_en' label={`${JOB_OPPORTUNITIES_FIELDS}.experience_en`} sortable={false}></TextField>
        <TextField source='number' label={`${JOB_OPPORTUNITIES_FIELDS}.number`}></TextField>
        <DateField
          source='create_at'
          label={`${COMMON_FIELDS}.date.created_at`}
          textAlign='center'
        />
        <DateField
          source='update_at'
          label={`${COMMON_FIELDS}.date.updated_at`}
          textAlign='center'
        />
        <DateField
          source='start_date'
          label={`${COMMON_FIELDS}.date.published_on`}
          textAlign='center'
        />
        <DateField
          source='end_date'
          label={`${COMMON_FIELDS}.date.expired_on`}
          textAlign='center'
        />
        <BooleanField
          source='is_published'
          label={`${COMMON_FIELDS}.published.label`}
          textAlign='center'
          sortable={false}
        />
      </Datagrid>
    </ListBase>
  )
}

export default JobOpportunityList